export enum ProjectFeature {
  Compliance = 'compliance',
  Documentation = 'documentation',
  Methods = 'methods',
  Implementation = 'implementation',
  Deployment = 'deployment',
  Agendas = 'agendas',
  Ai = 'ai',
  Codelists = 'codelists',
  Licensing = 'licensing',
  AuditReadiness = 'audit-readiness',
}
